import type { AssetType, ProcessingState, SortDirection, SortField } from '../../types';

/** One object because it is one reference to compare when deriving the assets query key. */
export type AssetQuery = {
  /** A non-empty search spans the library, ignoring the active folder. Debounced by the toolbar. */
  search: string;
  types: readonly AssetType[];
  states: readonly ProcessingState[];
  sort: { field: SortField; direction: SortDirection };
};

/** Where a fresh library starts. One place to read the defaults off, and what tests reset to. */
export const INITIAL_ASSET_QUERY: AssetQuery = {
  search: '',
  types: [],
  states: [],
  sort: { field: 'uploadDate', direction: 'desc' },
};
